module.exports = __webpack_public_path__ + "img/3289f4cc56559c66ec249393cfcb5835.3289f4cc.png";